// import request from '@/router/axios';
import { getUrl } from '@/router/axios';


function formatParam(param) {
    let re = '';
    for (let k in param) {
        re += `&${k}=${param[k]}`;
    }
    return re;
}

/**
 * 通用的导出
 * @param {String} mod 模块名称 system、lab、exp、exam...
 * @param {Object} params 参数
 */
export const exportExcel = (mod, params = {}) => {
        window.location.href = `${getUrl(`/api/${mod}/export`)}${formatParam(params)}`;
}